<template>
  <div>
    <b-row>
      <b-col md="6">
        <h1>{{ this.$route.params.name }}</h1>
      </b-col>
      <b-col md="6">
          <router-link to="/sitios/sitios"><b-button class="text-right mr-5" variant="success">Regresar a sitios</b-button></router-link>
      </b-col>
    </b-row>
    <SiteMap />
  </div>
</template>
<script>
import SiteMap from '../../../components/maps/siteMap/SiteMap'
export default {
  name: 'viewSite',
  components: {
    SiteMap,
  },
}
</script>
